import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function AlertTriangleOutlineIcon(props: SvgIconProps) {
  const fill = props.fill ?? props.color ?? '#3B3C40';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_19)'>
        <path
          d='M22.5601 16.3001L14.8901 3.58006C14.58 3.09488 14.1527 2.69558 13.6476 2.419C13.1425 2.14241 12.5759 1.99744 12.0001 1.99744C11.4243 1.99744 10.8577 2.14241 10.3526 2.419C9.84755 2.69558 9.42024 3.09488 9.1101 3.58006L1.4401 16.3001C1.16915 16.7517 1.02189 17.2667 1.01311 17.7934C1.00434 18.32 1.13436 18.8396 1.3901 19.3001C1.68578 19.8183 2.11376 20.2488 2.6303 20.5475C3.14684 20.8462 3.73343 21.0023 4.3301 21.0001H19.6701C20.2629 21.0064 20.8468 20.8562 21.363 20.5648C21.8792 20.2733 22.3093 19.8509 22.6101 19.3401C22.8734 18.8748 23.0075 18.3477 22.9987 17.8133C22.9899 17.2788 22.8385 16.7564 22.5601 16.3001ZM20.8601 18.3501C20.7399 18.5567 20.5655 18.7264 20.3557 18.841C20.146 18.9556 19.9089 19.0106 19.6701 19.0001H4.3301C4.09132 19.0106 3.85422 18.9556 3.64446 18.841C3.4347 18.7264 3.26029 18.5567 3.1401 18.3501C3.05233 18.198 3.00613 18.0256 3.00613 17.8501C3.00613 17.6745 3.05233 17.5021 3.1401 17.3501L10.8201 4.62006C10.9581 4.43777 11.1365 4.28992 11.3412 4.18813C11.5459 4.08634 11.7715 4.03337 12.0001 4.03337C12.2287 4.03337 12.4543 4.08634 12.659 4.18813C12.8637 4.28992 13.0421 4.43777 13.1801 4.62006L20.8501 17.3401C20.9413 17.4924 20.9902 17.6662 20.992 17.8437C20.9937 18.0212 20.9482 18.196 20.8601 18.3501Z'
          fill={fill}
        />
        <path
          d='M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z'
          fill={fill}
        />
        <path
          d='M12 8C11.7348 8 11.4804 8.10536 11.2929 8.29289C11.1054 8.48043 11 8.73478 11 9V13C11 13.2652 11.1054 13.5196 11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14C12.2652 14 12.5196 13.8946 12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13V9C13 8.73478 12.8946 8.48043 12.7071 8.29289C12.5196 8.10536 12.2652 8 12 8Z'
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_19'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
